import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  linkedSignal,
  TemplateRef,
  viewChild,
} from '@angular/core';
import {
  askFn,
  ButtonComponent,
  IconComponent,
  QuantityInputComponent,
  ResolvableModal,
  SoftSlotDirective,
  TranslatePipe,
  translator,
} from '@softline/ui-core';
import { BatchInfoComponent } from '@softapps/lager/core';
import { Bewekommscan } from '../../types/bewekommscan';

export interface ScanCorrectionResult {
  menge: number;
}

export type ScanCorrectionMode = 'confirm' | 'edit';

@Component({
  selector: 'soft-scan-correction-modal',
  imports: [
    ButtonComponent,
    IconComponent,
    SoftSlotDirective,
    QuantityInputComponent,
    TranslatePipe,
    BatchInfoComponent,
  ],
  templateUrl: './scan-correction-modal.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScanCorrectionModal extends ResolvableModal<ScanCorrectionResult | null> {
  readonly scan = input.required<Bewekommscan>();
  readonly mode = input<ScanCorrectionMode>('confirm');

  readonly #ask = askFn();
  readonly #t = translator();

  override readonly bottomTemplate = viewChild('bottomTemplate', { read: TemplateRef });

  readonly quantity = linkedSignal(() => this.scan().artikelMenge.menge);
  readonly isPallet = computed(() => !!this.scan().scanPalette);

  apply(): void {
    this.resolve({
      menge: this.isPallet() ? this.scan().artikelMenge.menge : this.quantity(),
    });
  }

  async remove(): Promise<void> {
    const answer = await this.#ask({
      title: this.#t('#KOMMISSIONIERUNG.DIALOGS.ERFASSTE_MENGEN.REMOVE_TITLE'),
      question: this.#t('#KOMMISSIONIERUNG.DIALOGS.ERFASSTE_MENGEN.REMOVE_QUESTION'),
      dismiss: true,
      dismissOnNavigation: false,
    });
    if (answer !== 'YES') return;
    this.resolve({ menge: 0 });
  }
}
